import styled from "@emotion/styled"
import Box, { BoxProps } from "./Box"

export interface FlexProps extends BoxProps {
  gap?: number | string
}

const Flex = styled(Box)<FlexProps>`
  display: flex;
  gap: ${({ gap }) => gap};
`

export default Flex
